export default "__VITE_ASSET__BhpgfanF__"